import { newAPI } from 'services';
import qs from 'qs';

export const fetchEventConfig = async (userId, establishmentId, options = {}) => {
  const response = await newAPI.get(
    `${userId}/establishment/${establishmentId}/event_scheduling/settings/view`,
    { silenceErrorToast: !!options?.silenceErrorToast }
  );
  return response.data;
}

export const fetchEmailConfigurations = async (userId, establishmentId) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/event_scheduling/settings/email-configurations/view`);
  return response.data;
}

export const updateEmailConfigurations = async (userId, establishmentId, params) => {
  const formattedParams = {
    confirmation: +params?.confirmation ? 1 : 0,
    cancelling: +params?.cancelling ? 1 : 0,
    d0: +params?.d0 ? 1 : 0,
    d1: +params?.d1 ? 1 : 0,
    d2: +params?.d2 ? 1 : 0
  }

  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/event_scheduling/settings/email-configurations/update`, qs.stringify(formattedParams));
  return response.data;
}

export const createEventConfig = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/event_scheduling/settings/new`, qs.stringify(params));
  return response.data;
}

export const updateEventConfig = async (userId, establishmentId, params) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/event_scheduling/settings/update`, qs.stringify(params));
  return response.data;
}